<template>
	<div class="login-container">
		<div class="login-left"
			:style="{ height: windowHeight + 'px', backgroundImage: 'url(icon/login/login-bg.jpg)' }">
			<div class="qrcode-layout">
				<div class="qrcode-container">
					<div class="text-content">
						<span>{{ $t('loginSlogan') }}</span>
					</div>
					<div class="footer-section" style="margin-top: 20px;">
						<div class="qr-section">
							<img src="/icon/common/qrcode.svg" alt="QR Code" class="qr-image">
							<span class="qr-text">{{ $t('scanToDownload') }}</span>
						</div>
						<div class="app-buttons">
							<button class="app-button app-store">
								<img src="/icon/common/download-ios.svg">
								<span class="app-text">
									<span class="download-text">{{ $t('downloadAppleStore') }}</span>
								</span>
							</button>
							<button class="app-button google-play">
								<img src="/icon/common/download-android.svg">
								<span class="app-text">
									<span class="download-text">{{ $t('downloadGooglePlay') }}</span>
								</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="login-form-wrapper">
			<div class="login-layout">
				<div style="display: flex;align-items: center;">
					<div class="section-divider" style="height: 30px;"></div>
					<h2 class="login-title">{{ $t('login') }}</h2>
				</div>
				<!-- Language Selector -->
				<div class="language-selector">
					<el-dropdown>
						<span class="dropdown-trigger">
							<img src="/icon/login/change-lang.svg" alt="">
							{{ language[$i18n.locale]}}
							<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="changeLanguage(item.value)" v-for="item in languagelist"
								:key="item.value">
								{{item.label}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>

			<el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0">
				<el-form-item prop="email">
					<div class="form-label">{{ $t('email2') }}<span class="required-mark">*</span></div>
					<el-input v-model="loginForm.email" :placeholder="$t('emailPlaceholder')"
						class="login-input"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<div class="form-label">{{ $t('password') }}<span class="required-mark">*</span></div>
					<el-input type="password" v-model="loginForm.password" :placeholder="$t('passwordPlaceholder')"
						class="login-input" show-password></el-input>
				</el-form-item>
				<div class="forgot-password">
					<a @click="openUpdatePassword">{{ $t('forgotPassword') }}</a>
				</div>
				<el-form-item>
					<el-button type="primary" @click="submitForm('loginForm')" class="login-button"
						:loading="loading">{{ $t('loginAccount') }}</el-button>
				</el-form-item>
			</el-form>

			<div class="register-link">
				<a @click="openRegiest">{{ $t('register') }}</a>
			</div>

			<div class="other-login-options">
				<div class="login-divider"></div>
				<div class="login-buttons">
					<div class="social-login-button apple-button">
						<img src="/icon/login/apple-login.png" alt="">
					</div>
					<div class="social-login-button google-button">
						<img src="/icon/login/goole-login.png" alt="">
					</div>
				</div>
			</div>
		</div>
		<!-- 注册对话框组件 -->
		<RegiestDialog :visible.sync="showRegiestDialog" />
		<!-- 修改密码对话框组件 -->
		<UpdatePasswordDialog :visible.sync="showUpdatePasswordDialog" />
	</div>
</template>

<script>
	import {
		md5
	} from "@/utils/md5.js";
	import storage from "@/utils/storage.js";
	import userApi from './api/user'
	import RegiestDialog from './components/RegiestDialog.vue'
	import UpdatePasswordDialog from './components/UpdatePasswordDialog.vue'
	export default {
		name: 'Login',
		components: {
			RegiestDialog,
			UpdatePasswordDialog
		},
		data() {
			return {
				language: {},
				languagelist: [], //语言包
				showRegiestDialog: false, // 是否显示注册对话框
				showUpdatePasswordDialog: false, // 是否显示修改密码对话框
				loading: false,
				loginForm: {
					email: '',
					password: ''
				},
				windowHeight: 0,
				windowWidth: 0
			}
		},
		computed: {
			rules() {
				return {
					email: [{
							required: true,
							message: this.$t('emailInvalid'),
							trigger: 'blur'
						},
						{
							type: 'email',
							message: this.$t('emailInvalid'),
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: this.$t('passwordPlaceholder'),
							trigger: 'blur'
						},
						{
							min: 6,
							message: this.$t('passwordPlaceholder'),
							trigger: 'blur'
						}
					]
				};
			}
		},
		mounted() {
			this.getWindowHeight()
			window.addEventListener('resize', this.getWindowHeight)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.getWindowHeight)
		},
		created() {
			//获取语言包
			userApi.getLanguage().then(res => {
				// 保持原有格式
				this.languagelist = res.result.map(item => ({
					value: item.langCode,
					label: item.displayName
				}));
				this.languagelist.map(item => {
					this.language[item.value] = item.label;
				})
			}).catch(error => {
				console.error("获取语言包失败:", error)
			})
		},
		methods: {
			openRegiest() {
				this.showRegiestDialog = true;
			},
			openUpdatePassword() {
				this.showUpdatePasswordDialog = true;
			},
			getWindowHeight() {
				this.windowHeight = window.innerHeight - 100;
				this.windowWidth = window.innerWidth / 2;
			},
			async submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						try {
							this.loading = true;
							// 调用登录API
							const res = await userApi.userLogin({
								username: this.loginForm.email,
								password: md5(this.loginForm.password)
							});
							if (res.success) {
								// 检查响应中是否包含accessToken和refreshToken
								if (res.result && res.result.accessToken) {
									// 存储accessToken
									storage.setToken(res.result.accessToken);
								}
								if (res.result && res.result.refreshToken) {
									// 存储refreshToken
									storage.setRefreshToken(res.result.refreshToken);
								}
								this.$message.success(this.$t('loginSuccess'));
								//获取用户基本信息
								this.getUserInfo();
							} else {
								if (res.code == 20002) {
									this.$message.error(this.$t('emailNotExist'))
								} else if (res.code == 20010) {
									this.$message.error(this.$t('passwordErr'))
								} else {
									this.$message.error(res.message);
								}
							}
						} catch (error) {
							this.$message.error('登录失败：' + (error.message || '未知错误'));
						} finally {
							this.loading = false;
						}
					} else {
						return false;
					}
				})
			},
			async getUserInfo() {
				const res = await userApi.getUserInfo();
				this.loading = false;
				if (res.success) {
					storage.setUserInfo(JSON.stringify(res.result));
					// 登录成功后跳转到首页
					this.$router.push('/home');
				}
			},
			//获取语言
			getLanguageList() {
				getLanguage().then((res) => {
					if (res.data.success) {
						// 保持原有格式
						this.languagelist = res.data.result.map(item => ({
							value: item.langCode,
							label: item.displayName
						}));

						// 设置当前语言（从i18n获取当前语言）
						this.currentLanguage = this.$i18n ? this.$i18n.getCurrentLanguage() : 'en';

					}
				});
			},
			changeLanguage(lang) {
				this.$i18n.locale = lang
				localStorage.setItem('language', lang)
			}
		},
	}
</script>

<style scoped>
	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: calc(100vh);
		background-color: #0167F7;
	}

	.login-form-wrapper {
		width: 500px;
		padding: 20px 30px;
		background-color: #fff;
		margin-top: 70px;
		border-radius: 8px;
	}

	.login-layout {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 30px;
	}

	/* Language Selector */
	.language-selector {
		text-align: right;
	}

	.dropdown-trigger {
		display: flex;
		align-items: center;
		cursor: pointer;
		color: #333;
	}

	.dropdown-trigger i {
		margin-right: 5px;
	}

	.dropdown-trigger img {
		width: 20px;
		margin-right: 5px;
	}

	/* Login Title */
	.login-title {
		margin-left: 5px;
		font-size: 24px;
		font-weight: bold;
		color: #333;
	}

	/* Form Styles */
	.form-label {
		font-size: 16px;
		color: #333;
	}

	.required-mark {
		color: #ff4d4f;
		margin-left: 4px;
	}

	.login-input {
		width: 100%;
		height: 40px;
		font-size: 14px;
	}

	.el-form-item {
		margin-bottom: 20px;
	}

	/* El Input Bottom Border Only */
	:deep .el-input__inner {
		border: none;
		border-bottom: 1px solid #d9d9d9;
		border-radius: 0;
		box-shadow: none;
		padding: 0;
	}

	:deep .el-input__inner:focus {
		border-bottom-color: #1890ff;
		box-shadow: none;
	}

	:deep .el-input {
		--el-input-bg-color: transparent;
		--el-input-border-color: transparent;
		--el-input-focus-border-color: transparent;
		--el-input-hover-border-color: transparent;
	}

	/* Forgot Password */
	.forgot-password {
		text-align: right;
		margin-bottom: 30px;
		cursor: pointer;
	}

	.forgot-password a {
		color: #ff4d4f;
		text-decoration: none;
		font-size: 14px;
	}

	/* Login Button */
	.login-button {
		width: 100%;
		height: 50px;
		font-size: 18px;
		background-color: #016AF8;
		border-color: #016AF8;
	}

	.login-button:hover {
		background-color: #40a9ff;
		border-color: #40a9ff;
	}

	/* Register Link */
	.register-link {
		cursor: pointer;
		text-align: center;
		margin-top: 20px;
		margin-bottom: 30px;
	}

	.register-link a {
		color: #1890ff;
		text-decoration: none;
		font-size: 16px;
	}

	/* Other Login Options */
	.other-login-options {
		margin-top: 30px;
	}

	.login-divider {
		height: 1px;
		background-color: #e8e8e8;
		margin-bottom: 30px;
	}

	.login-buttons {
		display: flex;
		justify-content: center;
		gap: 40px;
	}

	.social-login-button {
		border-radius: 50%;
		border: 1px solid #e8e8e8;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		height: 70px;
		width: 70px;
	}

	.apple-button img {
		width: 30px;
	}

	.google-button img {
		width: 30px;
	}

	.login-left {
		background-repeat: no-repeat;
		margin-left: -200px;
		margin-right: 10px;
		width: 900px;
		position: relative;
		background-size: cover;
		background-position: center;

	}

	.qrcode-layout {
		position: absolute;
		bottom: 70px;
		left: 38%;
		z-index: 10;
		color: rgba(255, 255, 255, 0.65);
		font-size: 13px;
	}

	.qrcode-container {
		display: inline-block;
	}

	@media (max-width: 2080px) {
		.qrcode-layout {
			bottom: 55px;
		}
	}

	@media (max-width: 1680px) {
		.qrcode-layout {
			bottom: 70px;
		}
	}


	/* Responsive adjustments */
	@media (max-width: 768px) {
		.login-form-wrapper {
			width: 90%;
			max-width: 400px;
			padding: 30px;
		}
	}

	@media (max-width: 480px) {
		.login-form-wrapper {
			width: 95%;
			padding: 20px;
		}

		.login-title {
			font-size: 20px;
			margin-bottom: 20px;
		}

		.el-form-item {
			margin-bottom: 15px;
		}

		.login-button {
			height: 36px;
			font-size: 14px;
		}
	}

	.qr-image {
		width: 120px !important;
		height: 120px !important;
		object-fit: contain;
	}

	.qr-text {
		font-size: 14px;
		color: rgba(255, 255, 255, 0.65);
		text-align: center;
	}

	.app-button.app-store:hover {
		background-color: #000;
	}

	.app-button.google-play:hover {
		background-color: #000;
	}
</style>